var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBackward10Seconds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.792 15.92v-3.39l-.19.22c-.28.31-.75.33-1.06.06a.756.756 0 0 1-.06-1.06l1.5-1.67c.21-.23.54-.31.83-.2.29.11.48.39.48.7v5.35c0 .41-.33.74-.75.74-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.761 3.49.82-1.02c.26-.32.21-.8-.12-1.05a.739.739 0 0 0-1.05.12L9.441 4c-.01.01-.01.02-.02.04-.03.04-.05.09-.07.13-.02.05-.04.09-.05.13a.66.66 0 0 0-.01.14v.2c.01.03.03.05.04.09.02.05.03.09.06.13.03.04.06.08.1.12.02.02.04.05.06.07.01.01.03.01.04.02.03.02.06.04.1.05.05.03.1.05.15.06.04.02.07.02.11.02.03 0 .05.01.08.01.02 0 .05-.01.07-.02h.1c.64-.15 1.24-.22 1.81-.22 4.49 0 8.14 3.65 8.14 8.14s-3.65 8.14-8.14 8.14-8.14-3.65-8.14-8.14c0-1.74.57-3.42 1.65-4.86a.75.75 0 0 0-1.2-.9c-1.28 1.7-1.95 3.69-1.95 5.76 0 5.31 4.32 9.64 9.64 9.64s9.64-4.32 9.64-9.64-4.34-9.63-9.65-9.63c-.08 0-.16.01-.24.01z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.92v-1.35c0-1.52 1.23-2.75 2.75-2.75s2.75 1.23 2.75 2.75v1.35c0 1.52-1.23 2.75-2.75 2.75s-2.75-1.23-2.75-2.75zm1.5-1.34v1.35a1.25 1.25 0 0 0 2.5 0v-1.35a1.25 1.25 0 0 0-2.5 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBackward10Seconds);
export default __webpack_public_path__ + "static/media/vuesax-bold-backward-10-seconds.349ff5a640335a374531f86cef54d8f0.svg";
export { ForwardRef as ReactComponent };